import { useEffect, useState } from "react";
import { _Entailment } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { Modal } from "../../../theme/Component/Modal";
import { Singleton } from '../../../../core/services/Singleton';
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { toast } from "react-toastify";
import { AppointmentManualEditor } from "../AppointmentManual/AppointmentManual.editor";
import { AppointmentGroupManualEditor } from "../AppointmentGroupManual/AppointmentGroupManual.editor";
import usePaginator from "../../../theme/Component/usePaginator";
import { _PayrollImportedDataCatalog } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { AccountantYear } from "../../GestionTH/EmployeeContract/ProductionPlan/AccountantYear";
import { MonthEditorbyconst } from "../../../RemoteAbstractAction/editors/MonthEditorbyconst";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { AccountEditor } from "../../../editor/AccountEditor";
import { ImportedDataConstantsList } from "./ImportedDataConstantsList";


export const PayrollImportedDataCatalog = () => {

    const payimported = useDataBean(_PayrollImportedDataCatalog);
    const single = Singleton.getInstance();
    const paginador = usePaginator();
    const [regexStr, setregexStr] = useState<any>(null);
    const [lista, setLista] = useState<any>([]);
    const [Year, setYear] = useState<number>(null)
    const [State, setState] = useState<number>(null)
    const [Acc, setAcc] = useState<number>(null)
    const [Month, setMonth] = useState<number>(null)
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [paginador.page])

    const getLista = () => {

        payimported.instance.getPayrollImportedDataCatalog(Acc, State, Year, Month, regexStr, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * 15);
                    paginador.setRegiPerPage(15);
                    setLista(resp.List)
                }
            }
        )

    }

    const create = () => {
        payimported.setBean({

        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        payimported.deleteItemVoid(payimported.bean).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const editaItem = () => {
        //console.log(entailment.bean);
        payimported.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDPayrollImportedData', visible: true },
        { title: 'Concepto a Importar', property: 'IDImportedPayrollConcept', visible: true },
        { title: 'Fecha Factor', property: 'FromDate', visible: true },
        { title: 'Año', property: 'Year', visible: true },
        { title: 'Mes', property: 'MonthName', visible: true },
        { title: 'Identificación', property: 'Nit', visible: true },
        { title: 'Nombres', property: 'Names', visible: true },
        { title: 'Apellidos', property: 'Surnames', visible: true },
        { title: 'Clase Factor', property: 'ValueTypeName', visible: true },
        { title: 'Cantidad', property: 'Quantity', visible: true },
        { title: 'Valor', property: 'Value', visible: true },
        { title: 'Estado', property: 'StateName', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Factores Salariales Importados">
            <div className="row">
                <div className="col-md-6">
                    <AccountEditor label="Tercero" idAccount={Acc} onChange={(e) => { setAcc(e) }}></AccountEditor>
                </div>
                <div className="col-md-6">
                    <ImportedDataConstantsList idSelector={State} onChange={(e) => { setState(e) }} />
                </div>
                <div className="col-md-6">
                    <AccountantYear idSelector={Year} onChange={(e) => { setYear(e) }} />
                </div>
                <div className="col-md-6">
                    <MonthEditorbyconst idSelector={Month} onChange={(e) => { setMonth(e) }} />
                </div>
                <div className="col-md-6">
                    <label>Búsqueda por Texto</label>
                    <input type="text" name="regexStr" className="form-control" value={regexStr} onChange={(e) => { setregexStr(e.target.value) }} />
                </div>
                <div className="col-md-6 mt-4 p-2">
                    <BasicButton icon="ri-database-2-line" eventClick={getLista}> Buscar</BasicButton>
                </div>
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={payimported.setBean} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador} customRows={15}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">

                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {payimported.bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}